import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemUiName, FormItemUiUserCode} from '../UI/FormChooseUi.jsx'
import Model from './ModelUv.mjs'

export const FormItemUvName = props => (
    <FormItemBizProp
        Model={Model}
        prop="uvName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemUvUserCode = props => (
    <FormItemBizProp
        Model={Model}
        prop="uvUserCode"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseUv(props) {
    return (
        <FormChooseDesign {...props}>
                <FormItemUiUserCode />
                <FormItemUiName />
                <FormItemUvUserCode />
                <FormItemUvName />
        </FormChooseDesign>
    )
}
